import Branding from "./Configurator";
import Integration from "./Integration";
import Billing from "./billing";

const routes = [
  {
    type: "collapse",
    key: "branding",
    route: "/branding",
    component: <Branding />,
  },
  {
    type: "collapse",
    key: "integration",
    route: "/integration",
    component: <Integration />,
  },
  {
    type: "collapse",
    key: "wallet",
    route: "/wallet",
    component: <Billing />,
  },
];

export default routes;
